<script setup lang="ts">
export interface Props {
  error?: string;
}
const props = withDefaults(defineProps<Props>(), {
  error: undefined,
});
</script>

<template>
  <div :class="$style.noticesErrorText" data-testid="noticesErrorText">
    <v-icon icon="mdi-alert-circle-outline" :class="$style.icon"></v-icon>
    <template v-if="props.error">
      <p :class="$style.text">{{ props.error }}</p>
    </template>
    <template v-else>
      <p :class="$style.text">Can’t get any notifications</p>
      <p :class="$style.text">Please, refresh your page</p>
    </template>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.noticesErrorText {
  text-align: center;
  padding: 2rem;
}
  .icon {
    color: colors.$color-red-700;
  }
  .text {
    margin: 0.5rem 0;
  }
</style>
